import React, { useId } from 'react';
import { getMoralIncreasePercentage } from '../utils/permanentDamage';

const levels = [['min', 'Minimo'], ['med', 'Medio'], ['max', 'Massimo']];
export default function MoralDamageSelect({ points, age, ageCoefficients, value, onChange, ...selectProps }) {
  const tooltipId = useId();
  const percentages = Object.fromEntries(levels.map(([key]) => [key,
    getMoralIncreasePercentage(points, age, key, ageCoefficients).toLocaleString('it-IT', { maximumFractionDigits: 2 })
  ]));
  const fractional = Number(String(points ?? '').replace(',', '.')) % 1 !== 0;
  return <span className="moral-increase-control">
    <select {...selectProps} value={value || ''} onChange={onChange} aria-describedby={tooltipId}>
      <option value="">Nessuno</option>
      {levels.map(([key, label]) => <option key={key} value={key} title={`Aumento del ${percentages[key]}% sul danno biologico`}>{label}</option>)}
    </select>
    <span id={tooltipId} role="tooltip" className="moral-increase-tooltip">
      <strong>Aumento sul danno biologico</strong>
      {levels.map(([key, label]) => <span key={key} className={value === key ? 'selected' : ''}>{label}<b>+{percentages[key]}%</b></span>)}
      {fractional && <small>Percentuale effettiva sui punti intermedi.</small>}
    </span>
  </span>;
}
